<template>
  <footer class="footer-bar">
    <div class="flex justify-content-between align-items-center px-4 py-3">
      <span class="text-base">© {{ currentYear }} Arengh Medical Supplier</span>
      <div class="hidden md:flex gap-3">
        
         <label class="text-base" ><em>“Success is not final; failure is not fatal: it is the courage to continue that counts.”</em> – Winston Churchill</label>
      </div>

      <span class="text-sm">v1.0.0</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data(){
    return{
        currentYear:null,
    }
  },
  mounted(){
    this.currentYear = new Date().getFullYear();
  }
};
</script>

<style scoped>
.footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--surface-card); /* PrimeVue theme color */
  border-top: 1px solid var(--surface-border);
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.05);
  z-index: 999;
}
</style>
